<template>
	<div
		ref="reservationForm"
		class="reservation-form-base"
		:class="[classesObj, customClass, `responsive-${responsiveAt}`]"
	>
		<q-overlay
			variant="dark"
			class="field-focus-overlay"
			:show="isOverlayVisible"
			fixed
			no-wrap
			:opacity="0.5"
			blur="none"
			no-spinner
			z-index="+1"
			@click="hideOverlay"
		/>
		<div class="form-groups">
			<slot />
			<slot name="submitBtn">
				<q-button
					id="offer-search-submit"
					class="offer-search-submit rounded-2"
					variant="primary"
					@click="submit"
				>
					{{ $t("label_check_availability") }}
				</q-button>
			</slot>
		</div>
	</div>
</template>

<script lang="ts" src="./reservation-form-base.ts"></script>
<style lang="scss" src="./reservation-form-base.scss"></style>
